import axios from "axios";
import apiUrl from '../../configs/constant';

export interface SysFile {
  id: number;
  server_link: string;
  jenis_file: string;
  created_at: string;
}

const getFiles = async (
  docId: number | string,
  docType: string
): Promise<SysFile[]> => {

  const res = await axios.get(apiUrl.apiUrl + "/system/attachment", {
    params: {
      doc_id: docId,
      doc_type: docType
    }
  });

  return res.data.data;
};

const deleteFile = async (id: number) => {
  await axios.delete(apiUrl.apiUrl + `/system/attachment/delete/${id}`);
};

export default {
  getFiles,
  deleteFile
};
